/* unplugin-vue-components disabled */import { render } from "./career.vue?vue&type=template&id=4418c0fd&scoped=true"
import script from "./career.vue?vue&type=script&lang=js"
export * from "./career.vue?vue&type=script&lang=js"

import "./career.vue?vue&type=style&index=0&id=4418c0fd&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4418c0fd"],['__file',"src/components/cards/persona/career.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4418c0fd"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4418c0fd', __exports__)) {
    api.reload('4418c0fd', __exports__)
  }
  
  module.hot.accept("./career.vue?vue&type=template&id=4418c0fd&scoped=true", () => {
    api.rerender('4418c0fd', render)
  })

}


export default __exports__